module.exports = __webpack_public_path__ + "img/武强乐器.8da3c55f.jpg";